import React, { useState } from 'react';
import { motion } from 'framer-motion';

const CandyBotSection = () => {
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const handlePaymentSubmit = (e) => {
    e.preventDefault();
    console.log(email, phone);
    setIsPaymentOpen(false);
  };

  return (
    <div>
      {/* motion.div + modale */}
    </div>
  );
};

export default CandyBotSection;
